//백엔드 api 서버 주소
export const URL = 'https://cookiepaper.kr/';

//서비스 오픈 시간
export const OPEN_DATE = '2023-11-10T18:00:00';
